import { Filters } from 'components'

const PaymentServiceTemplateFilter = ({ filter }) => {
  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome" name="name" />
      <select
        textfieldinput="true"
        name="active"
        label="Status"
        SelectProps={{ native: true }}
      >
        <option value="" />
        <option value="true">Ativo</option>
        <option value="false">Inativo</option>
      </select>
    </Filters>
  )
}

export default PaymentServiceTemplateFilter
